export default __webpack_public_path__ + "static/media/bdswissSCReal01_downloadMT4.6cad5a60.png";